<app-modal [active]="active" (dismiss)="closeModal()">
  <findalab-map *ngIf="map" [mapConfigInput]="map"></findalab-map>
</app-modal>
